import Vue from 'vue';

import { formatCurrency } from '@utils/money';

Vue.filter('formatCurrency', formatCurrency);
